import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Carousel, Row, Card } from "react-bootstrap";
import CardTestimonial from "./CardTestimonial";
import userData from "../data/userData";

//slider
import ItemsCarousel from "react-items-carousel";

const Testimonial = () => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);

  // const getListOfList = () => {
  //   var content = [];
  //   var tempContent = [];

  //   for (var i = 0; i < userData.length; i++) {
  //     if (i % 3 === 0) {
  //       content.push(tempContent);
  //       tempContent.pop(userData[i]);
  //     }
  //     tempContent.push(userData[i]);
  //   }

  //   if (tempContent.length) content.push(tempContent);

  //   return content;
  // };
  return (
    <div className="w-10" id="testimonial" className="hash">
      <Container className="mt-4">
        <div className="text-center p-5">
          {/* <h2>Successful Engineers</h2> */}
          <a href="#testimonial" class="btn-shine p-2">Successful</a>
          <a href="#testimonial" class="btn-shine p-0">Engineers</a>

        </div>
        <div className="row d-none d-md-block ">
          <ItemsCarousel
            infiniteLoop
            className="p-5 bg-light"
            style={{ color: "black" }}
            requestToChangeActive={setActiveItemIndex}
            activeItemIndex={activeItemIndex}
            numberOfCards={3}
            slidesToScroll={1}
            leftChevron={<img src="/is-less-than.png" alt="left" />}
            rightChevron={<img src="/is-greater-than.png" alt="right" />}
          >
            {/* {getListOfList().map((row) => (
            <Carousel.Item>
              <Row>
                {row.map((col) => (
                  <CardTestimonial key={col.id} {...col} />
                ))}
              </Row>
            </Carousel.Item>
          ))} */}
            {userData.map((data, index) => {
              return (
                <div className="row mx-2">
                  <div className="item col-sm-12 py-2">
                    <Card
                      className="mx-auto p-2 "
                      style={{
                        border: "1px solid #1663F6",
                        boxShadow: "5px 5px 5px grey",
                      }}
                    >
                      <Card.Body className="pb-0">
                        <img
                          alt="po"
                          src={data.image}
                          width="100"
                          height="100"
                          className="mx-auto mb-4 rounded-circle float-left"
                        />
                        <Card.Title className="mt-3 text-center">
                          &#8281;{data.name}&#8281;
                        </Card.Title>
                        <Card.Subtitle className="text-center text-primary">
                          {data.company}
                        </Card.Subtitle>
                      </Card.Body>
                      <Card.Body className="p-3 text-left">
                        <div className="mb-2">"{data.description}" </div>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              );
            })}
          </ItemsCarousel>
        </div>
        <div className="row d-block d-md-none">
          <ItemsCarousel
            infiniteLoop
            className="p-5 bg-light"
            style={{ color: "black" }}
            requestToChangeActive={setActiveItemIndex}
            activeItemIndex={activeItemIndex}
            numberOfCards={1}
            slidesToScroll={1}
            leftChevron={<img src="/is-less-than.png" alt="left" />}
            rightChevron={<img src="/is-greater-than.png" alt="right" />}
          >
            {/* {getListOfList().map((row) => (
            <Carousel.Item>
              <Row>
                {row.map((col) => (
                  <CardTestimonial key={col.id} {...col} />
                ))}
              </Row>
            </Carousel.Item>
          ))} */}
            {userData.map((data, index) => {
              return (
                <div className="item col-sm-12 px-3 py-2">
                  <Card
                    className="mx-auto p-2 "
                    style={{
                      border: "1px solid #1663F6",
                      boxShadow: "5px 5px 5px grey",
                    }}
                  >
                    <Card.Body className="pb-0">
                      <img
                        alt="po"
                        src={data.image}
                        width="100"
                        height="100"
                        className="mx-auto mb-4 rounded-circle float-left"
                      />
                      <Card.Title className="mt-3 text-center">
                        &#8281;{data.name}&#8281;
                      </Card.Title>
                      <Card.Subtitle className="text-center text-primary">
                        {data.company}
                      </Card.Subtitle>
                    </Card.Body>
                    <Card.Body className="p-3 text-left">
                      <div className="mb-2">"{data.description}" </div>
                    </Card.Body>
                  </Card>
                </div>
              );
            })}
          </ItemsCarousel>
        </div>
      </Container>
    </div>
  );
};

export default Testimonial;
